import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Standard } from '@getvim/vim-connect';
import useLocalStorage from 'react-localstorage-hook';
import { isEmpty } from 'lodash-es';
import { OrderViewed } from '../../mocks/standard-events';
import { FlexBox } from '../common/FlexBox';
import { MonacoEditor } from '../monaco-editor';

export const OrderViewedTab = () => {
  const [payload, setPayload] = useState<Standard.Events.OrderViewedPayload>();
  const [predefinedPayload, setPredefinedPayload] = useState<string>('');
  const [lastUsedPayload, setLastUsedPayload] = useLocalStorage('lastOrderViewedPayload', '');
  const [, setShouldPublish] = useLocalStorage('shouldPublishOrderViewed', false);

  useEffect(() => {
    handlePredefinedPayloadChange({ target: { value: lastUsedPayload } } as SelectChangeEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setShouldPublish(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePublish = () => setShouldPublish(true);

  const handlePredefinedPayloadChange = ({ target: { value } }: SelectChangeEvent) => {
    setPredefinedPayload(value);
    setLastUsedPayload(value);
    setPayload(OrderViewed.predefinedPayloads[value]);
  };

  return (
    <Accordion id="orderViewedTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>orderViewed</Typography>
        <Select
          displayEmpty
          value={predefinedPayload}
          size="small"
          id="order-viewed-select"
          onChange={handlePredefinedPayloadChange}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MenuItem value="">Choose</MenuItem>
          {Object.keys(OrderViewed.predefinedPayloads).map((value) => (
            <MenuItem value={value} key={value} id={`order-viewed-${value.replaceAll(' ', '-')}`}>
              {value}
            </MenuItem>
          ))}
        </Select>

        <Button
          id="publish-order-viewed"
          disabled={isEmpty(predefinedPayload)}
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handlePublish();
          }}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails id="orderViewedViewedAccordionDetails">
        <MonacoEditor onChange={setPayload} height="20rem" value={payload} />

        <FlexBox>
          <TextField
            id="orderViewedPayload"
            variant="outlined"
            size="small"
            value={JSON.stringify(payload)}
            sx={{ display: 'none' }}
          />
        </FlexBox>
      </AccordionDetails>
    </Accordion>
  );
};
